import React from "react"

const LinkBox = ({ text, href, width }) => (
  <a className="link-box" href={href} style={{ width: width || "auto" }}>
    {text}
  </a>
)

export default LinkBox
